const TAX_PERCENTAGE_PATTERN = /^(0|[1-9]\d{0,14})(\.\d{1,4})?$/;
const STORED_TAX_RATE_PATTERN = /^(0|[1-9]\d*)(\.\d{1,6})?$/;

function normalizeDecimal(integer, fraction) {
    const normalizedInteger = integer.replace(/^0+(?=\d)/, '');
    const normalizedFraction = fraction.replace(/0+$/, '');
    return normalizedFraction === '' ? normalizedInteger : normalizedInteger + '.' + normalizedFraction;
}

export function normalizeTaxPercentage(value) {
    const text = String(value).trim();
    const match = TAX_PERCENTAGE_PATTERN.exec(text);
    if (match == null) {
        throw new Error('Tax percentage must contain at most 15 integer digits and 4 decimal places');
    }
    return normalizeDecimal(match[1], match[2] == null ? '' : match[2].substring(1));
}

export function percentageToStoredTaxRate(value) {
    const percentage = normalizeTaxPercentage(value);
    const parts = percentage.split('.');
    const integer = parts[0];
    const fraction = parts.length === 2 ? parts[1] : '';
    const digits = integer + fraction;
    const decimalPosition = integer.length - 2;

    if (decimalPosition <= 0) {
        return normalizeDecimal('0', '0'.repeat(-decimalPosition) + digits);
    }
    return normalizeDecimal(
        digits.substring(0, decimalPosition),
        digits.substring(decimalPosition)
    );
}

export function storedTaxRateToPercentage(value) {
    const text = String(value).trim();
    const match = STORED_TAX_RATE_PATTERN.exec(text);
    if (match == null) {
        return '0';
    }
    const integer = match[1];
    const fraction = match[2] == null ? '' : match[2].substring(1);
    const digits = integer + fraction;
    const decimalPosition = integer.length + 2;

    if (decimalPosition >= digits.length) {
        return normalizeDecimal(digits + '0'.repeat(decimalPosition - digits.length), '');
    }
    return normalizeDecimal(
        digits.substring(0, decimalPosition),
        digits.substring(decimalPosition)
    );
}
